import { useMemo } from 'react';

import withPulse from 'components/Decorators/withPulse';
import Layout from 'components/Layout';
import AuthWrapper from 'providers/AuthWrapper';
import useCategoryDataStore from 'templates/stores/categoryDataStore';
import { collectSubCategoryMetaData } from 'templates/utils';
import useDevice from 'hooks/useDeviceType';
import GlobalProviders from 'providers/GlobalProviders';
import JSONLinkedData from 'components/JSONLinkedData';
import { SchemaType } from 'components/JSONLinkedData/types';
import { useSearchParams } from 'react-router-dom';
import getTemplatesNavigationData from 'utils/getTemplatesNavigationData';
import TemplateCategories from './Categories';

function TemplatesPage() {
  const { isMobile } = useDevice();
  const [query] = useSearchParams();

  const { categoryData } = useCategoryDataStore(state => ({
    categoryData: state.category,
  }));

  const { breadCrumbsData } = useMemo(
    () => getTemplatesNavigationData({ query, selectedCategory: categoryData }),
    [query, categoryData],
  );

  const breadcrumbSchema = useMemo(() => {
    const homeItem = {
      position: 1,
      anchor: 'Home',
      link: '/',
    };

    const templateItems = breadCrumbsData?.map((item, index) => ({
      position: index + 2,
      anchor: item.title || item.display_name,
      link: item.item_id === 'templates' ? '/templates/' : `/templates/${item.name}/`,
    }));

    return [homeItem, ...(templateItems || [])];
  }, [breadCrumbsData]);

  const metaCollection = useMemo(() => {
    return collectSubCategoryMetaData(
      categoryData?.display_name,
      categoryData?.meta_title,
      categoryData?.meta_description,
    );
  }, [categoryData?.display_name, categoryData?.meta_title, categoryData?.meta_description]);

  return (
    <GlobalProviders isLocalized={false} dropdownLanguagesList={{}} slug="" dataFetched>
      <AuthWrapper>
        <Layout
          ogDescription={metaCollection.ogDescription}
          metaDescription={metaCollection.description}
          ogTitle={metaCollection.ogTitle}
          title={metaCollection.title}
          canonicalUrl={metaCollection.canonicalUrl}
          isMobile={isMobile}
          isLocalized={false}
          hasDefaultBreadcrumb={false}
          footerRelevantLinkEnabled={false}
        >
          {breadcrumbSchema && (
            <JSONLinkedData data={breadcrumbSchema} type={SchemaType.ItemList} />
          )}
          <TemplateCategories />
        </Layout>
      </AuthWrapper>
    </GlobalProviders>
  );
}

export default withPulse(TemplatesPage);
